import { MARKETS, type Market } from '@shared/services/amazonService'
import { PillPicker } from './PillPicker'

/**
 * Which Amazon: a menu of our own rather than the browser's (Huanrui,
 * 2026-10-02). The browser draws a <select>'s list itself -- a grey box with
 * a blue highlight that matches nothing on the page -- and it cannot be
 * styled. This one is drawn like the bar it sits in: dark glass in the middle
 * of the empty page, white once the bar has moved up (amazon.css).
 *
 * Keyboard as a list box: Enter, Space or the arrows open it; the arrows move,
 * Enter picks, Escape or Tab closes. A click anywhere else closes it.
 */
export function MarketPicker({
  value,
  onChange,
  short = false,
}: {
  value: Market
  onChange: (next: Market) => void
  /** The button names the Amazon by its two letters -- where room is short (the Miro panel). */
  short?: boolean
}) {
  return <PillPicker value={value} options={MARKETS} onChange={onChange} short={short} name="Which Amazon" />
}
